import { useEffect } from 'react';

// \u2705 Critical assets to preload for instant navigation
import PulseIcon from '../assets/pulse.png';
import LeaderboardIcon from '../assets/leaderboard.png';
import InboxImg from '../assets/inbox.png';
import AppLogo from '../assets/Icon.png';
import BackIcon from '../assets/back.png';

/**
 * Preload critical assets for instant page navigation
 * NO VISUAL CHANGES - just faster loading
 */
const AssetPreloader = () => {
    useEffect(() => {
        // Preload images by creating Image objects
        const imagesToPreload = [
            PulseIcon,
            LeaderboardIcon,
            InboxImg,
            AppLogo,
            BackIcon
        ];

        imagesToPreload.forEach(src => {
            const img = new Image();
            img.src = src;
        });
    }, []);

    return null; // This component renders nothing
};

export default AssetPreloader;
